import { getImageBlurDataUrl } from "@/src/utils/constant";
import Image from "next/image";
import Link from "next/link";
import React from "react";
import { Paragraph } from "../common/Paragraph";
import ShareSection from "../common/SocialShareButton";
import { Badge } from "../ui/badge";
import FavoriteButton from "../common/FavouriteButton";

const ProductCard = ({
  isLoading,
  data,
  priority,
}: {
  isLoading?: boolean;
  data: any;
  priority: boolean;
}) => {
  if (isLoading) {
    return (
      <div className="flex w-full animate-pulse flex-col gap-4 sm:w-[45%] lg:w-[22%]">
        {/* Image Placeholder */}
        <div className="relative h-80 w-full rounded-md bg-gray-200 dark:bg-gray-700"></div>

        {/* Product Name and Price Placeholder */}
        <div className="flex justify-between">
          <span className="h-4 w-1/2 rounded-md bg-gray-200 dark:bg-gray-700"></span>
        </div>

        {/* Description Placeholder */}
        {/* <div className="w-full h-3 bg-gray-200 dark:bg-gray-700 rounded-md"></div> */}

        {/* Button Placeholder */}
        <div className="flex justify-between">
          <span className="h-4 w-1/4 rounded-md bg-gray-200 dark:bg-gray-700"></span>
          <div className="h-8 w-20 rounded-2xl bg-gray-200 dark:bg-gray-700"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex w-full flex-col gap-2 rounded-md border p-4 md:gap-4 relative">


      <div className=" absolute top-0 right-0 z-10">
        <FavoriteButton productId={data?._id} initialFavorite={data?.isFavorite || false} />
      </div>


      <Link
        href={`/product/${data?.slug}`}
        // target="_blank"
        // rel="noopener noreferrer"
        // className="w-full flex flex-col gap-4 sm:w-[45%] lg:w-[22%]"
        className="flex w-full flex-col gap-4"
      >
        <div className="relative h-64 w-full group">

          {/* If we use fill the parent should be relative */}
          {/* z-10 = bring the item to front */}
          {/* <Image
            src={data?.imageUrls[0]}
            alt="product"
            fill
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
            className="easy absolute z-10 rounded-md object-cover transition-opacity duration-500 hover:opacity-0"
            placeholder="blur"
            blurDataURL={getImageBlurDataUrl()}
            priority={!!priority}
            onContextMenu={(e) => e?.preventDefault()}
          />
          <Image
            src={data?.imageUrls[1]}
            alt="product"
            fill
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
            className="absolute rounded-md object-cover"
            placeholder="blur"
            blurDataURL={getImageBlurDataUrl()}
            priority={!!priority}
            onContextMenu={(e) => e?.preventDefault()}
          /> */}

          <Image
            src={data?.imageUrls[0]}
            alt={`front-image`}
            fill
            sizes="(max-width: 640px) 100vw, (max-width: 1200px) 50vw, 33vw"
            // sizes={"45"}
            className="absolute rounded-md object-contain transition-all duration-500 ease-in-out group-hover:opacity-0"
            placeholder="blur"
            // layout="fill"
            blurDataURL={getImageBlurDataUrl()}
            priority={priority}
            onContextMenu={(e) => e?.preventDefault()}
          />
          <Image
            src={data?.imageUrls[1] ?? data?.imageUrls[0]}
            alt={`back-image`}
            fill
            // sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
            // layout="fill"
            sizes="(max-width: 640px) 100vw, (max-width: 1200px) 50vw, 33vw"
            className="absolute rounded-md object-contain opacity-0 transition-all duration-500 ease-in-out group-hover:opacity-100"
            placeholder="blur"
            blurDataURL={getImageBlurDataUrl()}
            priority={priority}
            onContextMenu={(e) => e?.preventDefault()}
          />
        </div>

        {/* PRODUCT TEXT */}

        {/* <span className="font-normal text-sm line-clamp-2">
        {data?.title ?? ""}
      </span> */}
        <Paragraph className="line-clamp-2">{data?.title ?? ""}</Paragraph>

        {/* <div className="text-sm text-gray-500">My Description</div> */}

        <div className="flex justify-between">
          <span className="font-medium">
            $
            {new Intl.NumberFormat("en-US").format(
              data?.productPrice?.find((e: any) => e?.currency === "USD")
                ?.price || 0,
            )}
          </span>

          <button className="w-max rounded-2xl px-4 py-2 text-xs text-main-default ring-1 ring-slate-300 hover:bg-main-default hover:text-white">
            Buy now
          </button>
        </div>
      </Link>
      {/* <CopyButton textToCopy={`${process.env.NEXT_PUBLIC_BASE_URL}/product/${data?.slug}`} /> */}
      <ShareSection
        url={`${process.env.NEXT_PUBLIC_BASE_URL}/product/${data?.slug}`}
        title={`${data?.title}`}
      />

      <div className="flex flex-wrap gap-2 ">
        {data?.categoryIds?.slice(0, 3).map((e: any, i: number) => (
          <Badge key={i} variant={"outline"} className="text-gray-500">{e?.name} </Badge>
        ))}
      </div>
    </div>
  );
};

export default ProductCard;
